export default __webpack_public_path__ + "static/media/mai.c528249d.gif";